import React from 'react';
import {
    IconButton,
    Typography,
    Stack,
    Button,
} from '@mui/material';
import { ChevronLeft } from '@mui/icons-material';


interface HeaderProps {
    title: string;
    backAction?: () => void;
    backActionLabel?: string;
    headerActions?: React.ReactNode;
}

const Header: React.FC<HeaderProps> = ({ title, backAction, backActionLabel, headerActions }) => {

    return (
        <Stack
            direction="column"
            justifyContent="space-between"
            alignItems="flex-start"
            pt={{ xs: 2, md: 0 }}
            pb={2}
            px={{ xs: 2, md: 0 }}
        >
            <Stack direction="row" spacing={1} alignItems="center">
                {backAction && (
                    <Button size="small" startIcon={<ChevronLeft />} onClick={backAction}>
                        {backActionLabel ?? 'Back'}
                    </Button>
                )}
            </Stack>
            <Stack
                direction="row"
                flex={1}
                spacing={2}
                alignItems="center"
                justifyContent="space-between"
                width="100%"
            >
                <Typography variant="h5" color="text.primary">{title}</Typography>
                {headerActions}
            </Stack>
        </Stack>
    );
};

export default Header; 